import { v4 as uuidv4 } from 'uuid'

import FeedbackOne from 'assets/images/feedback/feedback2024/feedbackOne.png'
import FeedbackTwo from 'assets/images/feedback/feedback2024/feedbackTwo.png'
import FeedbackThree from 'assets/images/feedback/feedback2024/feedbackThree.png'
import FeedbackFour from 'assets/images/feedback/feedback2024/feedbackFour.png'
import FeedbackFive from 'assets/images/feedback/feedback2024/feedbackFive.png'
import FeedbackSix from 'assets/images/feedback/feedback2024/feedbackSix.png'
import FeedbackSeven from 'assets/images/feedback/feedback2024/feedbackSeven.png'
import FeedbackEight from 'assets/images/feedback/feedback2024/feedbackEight.png'
import FeedbackNine from 'assets/images/feedback/feedback2024/feedbackNine.png'
import FeedbackTen from 'assets/images/feedback/feedback2024/feedbackTen.png'
import FeedbackEleven from 'assets/images/feedback/feedback2024/feedbackEleven.png'
import FeedbackTwelve from 'assets/images/feedback/feedback2024/feedbackTwelve.png'
import FeedbackThirteen from 'assets/images/feedback/feedback2024/feedbackThirteen.png'
import FeedbackFourteen from 'assets/images/feedback/feedback2024/feedbackFourteen.png'
import FeedbackFifteen from 'assets/images/feedback/feedback2024/feedbackFifteen.png'
import FeedbackSixteen from 'assets/images/feedback/feedback2024/feedbackSixteen.png'
import FeedbackSeventeen from 'assets/images/feedback/feedback2024/feedbackSeventeen.png'
import FeedbackEighteen from 'assets/images/feedback/feedback2024/feedbackEighteen.png'
import FeedbackNineteen from 'assets/images/feedback/feedback2024/feedbackNineteen.png'
import FeedbackTwenty from 'assets/images/feedback/feedback2024/feedbackTwenty.png'

const feedbackData2024 = [
  {
    id: uuidv4(),
    image: FeedbackOne,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7241059481218871296/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwenty,
    link: 'https://t.me/AWSUGArmeniaChannel',
  },
  {
    id: uuidv4(),
    image: FeedbackTwo,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7241339263093534720/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFive,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7243296183530459136/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackThree,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7241732728436510720/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFour,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7242192019182292995/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSix,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7245140658380828672/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSeven,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7251862199793541122/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackEight,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7240724846416973825/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackNine,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7240741663789232128/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackEleven,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7242636527850192896/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7242209523086557184/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackTwelve,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7243378954231758848/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackThirteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7244347102330290178/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFourteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7244696389912268800/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackFifteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7250782442565881856/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSixteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7240804787519119361/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackNineteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7240648123432210432/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackSeventeen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7240707454785777666/?actorCompanyId=93086989',
  },
  {
    id: uuidv4(),
    image: FeedbackEighteen,
    link: 'https://www.linkedin.com/feed/update/urn:li:activity:7241303502247931904/?actorCompanyId=93086989',
  },
]

export default feedbackData2024
